<div class="auth">
  <div class="auth__component-wrapper">
    <a [routerLink]="['/login']" class="auth__logo">
      <img alt="logo" class="auth__logo-image" src="/assets/images/analytics.svg">
    </a>

    <div class="auth__component-contents">
      <router-outlet></router-outlet>
    </div>
  </div>

  <coa-description class="auth__description"></coa-description>
</div>
